// popup.component.ts
import { trigger, transition, style, animate, state } from '@angular/animations';
import { CommonModule } from '@angular/common';
import {
  Component,
  ViewChild,
  ViewContainerRef,
  Type,
} from '@angular/core';
import { ClickOutsideDirective } from '../../shared/directives/click-outside/click-outside.directive';

@Component({
  selector: 'app-popup',
  standalone:true,
  imports:[CommonModule, ClickOutsideDirective],
  template: `
    <div
      class="popup-backdrop"
      (click)="close()"
    >
      <div
        [@slideIn]="isVisible ? 'in' : 'out'"
       class="popup-content" appClickOutside [isOpen]="isVisible" (clickOutside)="close()" (click)="$event.stopPropagation()">
        <ng-template #container></ng-template>
      </div>
    </div>
  `,
  animations: [
    trigger('slideIn', [
      state(
        'out',
        style({
          transform:'translateY(100%)', 
          opacity: 0
        })
      ),
      transition(':enter', [
        style({ transform: 'translateY(100%)', opacity: 0 }),
        animate(
          '300ms ease-out',
          style({ transform: 'translateY(0)', opacity: 1 })
        ),
      ]),
      transition('in => out', [
        animate(
          '200ms ease-in',
          style({ transform: 'translateY(100%)', opacity: 0 })
        ),
      ]),
    ]),
  ],
  styleUrls: ['./popup.component.scss'],
})
export class PopupComponent {
  isVisible = false;
  @ViewChild('container', { read: ViewContainerRef, static: true }) container!: ViewContainerRef;
  detech?:(data?:any) => void;


  close(): void {
    this.isVisible = false;
    setTimeout(() => {
      this.container.clear();
      if(this.detech)
      this.detech();
    },200)
  }
  

  setContent<T>(component: Type<T>, data?: any) {
    this.container.clear();
    const ref = this.container.createComponent<T>(component);
    if (data && 'data' in (ref.instance as any)) {
      (ref.instance as any).data = data;
    }
  }
}
